import WorkItem from '@/views/work-item/work-item.view.vue';

export default [
  {
    path: '/:projectName/work-items',
    name: 'work-items',
    component: WorkItem,
  },
];
